import SpriteFlowerObject from './SpriteFlowerObject'
import GlbFlowerObject from './GlbFlowerObject'

class FlowerObject {
    constructor(initData) {
        const resource = initData.resource || {};
        const renderType = resource.resourceRenderType || (resource.detail && resource.detail.format === 'glb' ? 'glb' : 'sprite');
        if (renderType === 'glb') {
            return new GlbFlowerObject(initData);
        }
        return new SpriteFlowerObject(initData);
    }
}

export default FlowerObject;
